<div class="dialog">
    <div class="dialog-title">
        <h6 class="semi-bold">Edit Terms & condition <img class="mt-1 pr-2" src="assets/svg/close-white.svg" alt="close" (click)="close()"></h6>
    </div>
    <div class="content">
        <div class="head container-fluid mr-0 ml-0">
            <h6 class="semi-bold mb-0">For Manufacturing Enquiry</h6>
        </div>
        <div class="terms mt-3" [formGroup]="termsForm">
            <textarea formControlName="terms_and_conditions" class="container-fluid" name="terms_and_conditions"></textarea>
        </div>
        <div class="row button mt-4 ">
            <button class="white button-semibold mr-2" (click)="close()">Cancel</button>
            <button class="orange button-semibold ml-2" (click)="submit()">Confirm</button>
        </div>
    </div>
</div>